import React, { SyntheticEvent, useEffect, useState } from 'react';
import filtersStyles from '../../Filters.module.scss';
import { Action, CloseLight } from 'esa-ui-library';
import { useStore } from '../../../../../common';
import { PropertyType } from 'esa-ui-library/lib/types';
import { FilterDropdown } from '../FilterDropdown/FilterDropdown';
import { getActiveLabels, getFilterValue, getUpdateOptions } from '../../Filters.helper';
import { cloneDeep, find } from 'lodash';
import { selectPreselectedOptions } from '../../Filters.helper';
import useFilters from '../../../../../common/hooks/useFilters';

const DevicesFilter = (): JSX.Element => {
	const [{ devices, filters }] = useStore();
	const [filterOptions, setFiltersOptions] = useState<PropertyType[]>([]);
	const [opened, setOpened] = useState(false);
	const { onFilter } = useFilters();

	const onFilterChange = (option: PropertyType) => {
		const updateOptions = getUpdateOptions(option, devices);
		const filterValue = getFilterValue(updateOptions);
		setOpened(false);
		onFilter([{ name: 'devices', value: filterValue }]);
	};

	const onFilterRemove = (e: SyntheticEvent) => {
		e.stopPropagation();

		onFilter([{ name: 'devices', value: '' }]);
	};

	const getLabelContent = () => {
		const activeLabels = getActiveLabels(filterOptions);
		if (!activeLabels.length) return 'All';

		return (
			<>
				{activeLabels[0]}
				{activeLabels.length > 1 ? `+${activeLabels.length - 1}` : ''}
				<i className={filtersStyles.ClearFilter} onClick={onFilterRemove}>
					<CloseLight size={16} />
				</i>
			</>
		);
	};

	useEffect(() => {
		if (devices) {
			setFiltersOptions(cloneDeep(devices));
		}
	}, [devices]);

	useEffect(() => {
		const filter = find(filters, ['name', 'devices'])?.value || '';
		setFiltersOptions(selectPreselectedOptions(devices, filter));
	}, [filters]);

	return (
		<Action
			label='Devices'
			labelContent={getLabelContent()}
			select
			controlled
			onDropdownChange={setOpened}
			opened={opened}
			className={`${filtersStyles.Filter} 
			${getActiveLabels(filterOptions).length ? filtersStyles.Active : ''} `}
			dataId='devices-filter'
		>
			<FilterDropdown data={filterOptions} onChange={onFilterChange} isSearchable />
		</Action>
	);
};

export { DevicesFilter };
